module.exports = __webpack_public_path__ + "static/media/TC 2.14456d6c.jpg";